/**
 * Project Spotlight — Hover-cycle interaction.
 *
 * Each panel (.ode-ps__panel--left, .ode-ps__panel--right) holds N frames.
 * - 1 project → 1 or 2 frames (front + optional back)
 * - 2 projects → up to 4 frames (front+back × 2)
 *
 * Cycle on hover (mouseenter):
 *   data-state advances by 1 → wraps back to 0 at frame-count
 *
 * The matching .ode-ps__frame[data-frame="<state>"] becomes visible
 * via CSS attribute selectors. Only one frame per panel is visible
 * at any time; transitions cross-fade between them.
 *
 * On touch devices: cycling is disabled (front of first project shows).
 * With prefers-reduced-motion: CSS swaps to a flat opacity fade.
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.ode-project-spotlight').forEach(function (section) {
      new ProjectSpotlight(section);
    });
  }

  function ProjectSpotlight(el) {
    this.el = el;
    this.panels = Array.prototype.slice.call(el.querySelectorAll('.ode-ps__panel.has-cycle'));
    if (this.panels.length === 0) return;

    /* Hover-capable devices advance on mouseenter; touch-only devices
       advance on tap (click). Detected once at init. */
    this.hasHover = window.matchMedia('(hover: hover)').matches;
    this.bindEvents();
  }

  ProjectSpotlight.prototype.bindEvents = function () {
    var self = this;

    this.panels.forEach(function (panel) {
      if (self.hasHover) {
        /* Desktop: cycle on mouse enter */
        panel.addEventListener('mouseenter', function () {
          self.advance(panel);
        });
      } else {
        /* Touch: cycle on tap. Skip when the tap lands on a link
           inside the panel (e.g. the project info link) so the link
           navigates naturally instead of advancing the cycle. */
        panel.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('a')) return;
          self.advance(panel);
        });
      }
    });
  };

  /**
   * Advance the panel's data-state to the next frame, wrapping at
   * data-frame-count. Adds .transitioning on the first hover so the
   * initial paint isn't animated.
   */
  ProjectSpotlight.prototype.advance = function (panel) {
    var current = parseInt(panel.dataset.state, 10) || 0;
    var max = parseInt(panel.dataset.frameCount, 10) || 1;
    if (max <= 1) return;

    var next = (current + 1) % max;
    panel.classList.add('transitioning');
    panel.dataset.state = String(next);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
